import React from 'react';

const Disclaimer = (props) => {
  const {content, image} = props.data;

  return (
    <div className="nppe2-fc-feeding-guidelines-disclaimer" id="fc-screenshot-feeding-guidelines-disclaimer">
      <div className="row">
        <div className="col-xs-12 nppe2-fc-feeding-guidelines-disclaimer__text">
          {content}
        </div>
        <div className="col-xs-12 nppe2-fc-feeding-guidelines-disclaimer__img">
          <img src={image} alt="" />
        </div>
      </div>
    </div>
  );
}

export default Disclaimer;
